export default __webpack_public_path__ + "static/media/admin-truck-details.2604463d.png";